module.exports = __webpack_public_path__ + "static/media/heroHome.f952137d.png";